import { toNumber } from 'lodash'

export default {
    buildNonEmptyChartData: data => {
        const _data = []
        for (const val of data) {
            const pointData = {
                coordinates: [toNumber(val.volume_rate_on_non_empty_profile_based_on_database) * 100, toNumber(val.gain_on_non_empty_profiles)],
                formula: val.definition,
                rank: val.rank
            }
            _data.push(pointData)
        }
        return _data
    },

    buildAllEmptyChartData: data => {
        const _data = []
        for (const val of data) {
            const pointData = {
                coordinates: [toNumber(val.volume_rate_on_non_empty_profile_based_on_database) * 100, toNumber(val.gain_on_all_profiles)],
                formula: val.definition,
                rank: val.rank
            }
            _data.push(pointData)
        }
        return _data
    }
}
